import { createApp, h, provide } from "vue";
import MetfoneLayout from "./layout/metfone-layout.vue";
import router from "./router";
import store from "./store";
import helper from "./helpers";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import "./plugins/global-config";
import "./scss/app.scss";
import axios from "axios";
import VueAxios from "vue-axios";
import errorHandler from "./plugins/interceptor";
import { $bridge } from "web-jsbridge";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { DefaultApolloClient } from "@vue/apollo-composable";
// import VueLodash from 'vue-lodash'
import lodash from "lodash";
import { apiClient } from "@/ultis/apiClient";
import { Popover } from "vant";
import VueCookies from "vue-cookies";
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css"; //required if you're not going to override default slots

import Spinner from "vue-simple-spinner";
import { VueSpinnersPlugin } from "vue3-spinners";
// Plugins
import VueI18n from "./plugins/vue-i18n";
import KProgress from "k-progress-v3";
import { Loading } from "vant";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import {
  Button,
  Cell,
  CellGroup,
  Divider,
  Form,
  Field,
  List,
  Empty,
  Toast,
  Calendar,
  Icon,
  Dialog,
} from "vant";
import { FloatingBubble } from "vant";

import "./assets/css/style.css";

import bottomNavigationVue from "bottom-navigation-vue";
import "bottom-navigation-vue/dist/style.css";
// Graphql

import NotifyEsim from "./store/modules/esimNotifyStore.js";

const defaultClient = new ApolloClient({
  uri: "https://rickandmortyapi.com/graphql",
  cache: new InMemoryCache(),
});

const app = createApp({
  setup() {
    provide(DefaultApolloClient, defaultClient);
  },
  render() {
    return h(MetfoneLayout);
  },
});
app.config.productionTip = false;
app.config.devtools = true;
app.component("infinite-loading", InfiniteLoading);
app.component("k-progress", KProgress);
// Disable console logs in production
if (process.env.NODE_ENV === "production") {
  app.config.silent = true;
}
app.use(bottomNavigationVue);
// vant
app
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Divider)
  .use(Form)
  .use(Field)
  .use(List)
  .use(Empty)
  .use(Popover)
  .use(Toast)
  .use(Calendar)
  .use(Icon)
  .use(Dialog)
  .use(FloatingBubble);

app.use(VueI18n);
app.use(lodash);
app.use(apiClient);
app.use(VueCookies);
app.use(VueSpinnersPlugin);
app.use(NotifyEsim);
app.use(Loading);

const requireComponent = require.context(
  "./components",
  true,
  /(st-)[\w-]+\.vue$/,
);
requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName.replace(/^\.\/ui\/|^\.\/ui-custom\//, "").replace(/\.\w+$/, ""),
    ),
  );
  app.component(componentName, componentConfig.default || componentConfig);
});

app.config.globalProperties.$filters = {
  truncate: function (text, length, clamp) {
    clamp = clamp || "...";
    const node = document.createElement("div");
    node.innerHTML = text;
    const content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
  },
};

errorHandler(axios);
const bridgeStubHandlers = {};
const bridgeStub = {
  callHandler(name, data) {
    console.log("[bridge Dev] callHandler", name, data);
    switch (name) {
      case "setBarTitle":
      case "closeApp":
      case "backToHomePage":
      case "doPayment":
      case "setAudioPlay":
      case "setPlayList":
      case "switchPlayerMode":
      case "share":
      case "download":
      case "confirmOnClose":
        return Promise.resolve({ success: true, fakeAPI: true });
      case "getContact":
        return Promise.resolve({
          name: "Test User",
          phone: "+85512345678",
        });
      case "getDefaultAcc": // Wing không có API này, nên tạm thời trả về resolve để không bị lỗi khi gọi, sau này nếu cần thì sẽ sửa lại
        /*
        return Promise.resolve({
          accountName: "Test Account",
          accountNumber: "85500000000",
          currency: "USD",
        });
        */
       return Promise.resolve();

      case "getProfile":
        return Promise.resolve({
          id: "988216",
          middleName: "",
          osVersion: "26.0",
          appVersion: "1.0.1",
          email: "long.nguyenminh2704@gmail.com",
          secret_key:
            "B9DF5CBCA2A2249406B2DB871E0FB04BABAEF09027310527992891A1AF5864AD",
          lastName: "Metfone",
          nationality: "KHM",
          fullName: "UAT TEST Metfone",
          lang: "en_US", //en_US || kh_KH
          appLang: "en", //en || kh
          dobShort: "16-12",
          sex: "M",
          appId: "7f762be3-eb57-442d-b8e5-8a9aa957d180",
          phone: "+855315445204",
          firstName: "UAT TEST",
        });
      case "getNID":
        return Promise.resolve({
          id: "NID123456789",
          type: "passport",
        });
      case "openMap":
        return Promise.resolve({ opened: true });
      case "uploadFile":
        return Promise.resolve({
          fileUrl: "https://via.placeholder.com/150",
          fileName: "mock-upload.png",
        });
      case "addCalendar":
        return Promise.resolve({ added: true });
      case "getPlayingId":
        return Promise.resolve({ playId: "mock-play-id" });
      case "getStatus":
        return Promise.resolve({ status: "OK" });
      default:
        return Promise.resolve({});
    }
  },
  registerHandler(name, callback) {
    console.log("[bridge Dev] registerHandler", name);
    bridgeStubHandlers[name] = callback;
  },
};
const isNotInsideMiniAppError = (err) => {
  if (!err) return false;
  const message = typeof err === "string" ? err : err.message || err.toString();
  return /not inside a mini app/i.test(message);
};
const bridge = {
  callHandler(name, data) {
    if ($bridge && typeof $bridge.callHandler === "function") {
      try {
        const result = $bridge.callHandler(name, data);
        if (result && typeof result.then === "function") {
          return result.catch((err) => {
            if (isNotInsideMiniAppError(err)) {
              return bridgeStub.callHandler(name, data);
            }
            return Promise.reject(err);
          });
        }
        return result;
      } catch (err) {
        if (isNotInsideMiniAppError(err)) {
          return bridgeStub.callHandler(name, data);
        }
        return Promise.reject(err);
      }
    }
    return bridgeStub.callHandler(name, data);
  },
  registerHandler(name, callback) {
    if ($bridge && typeof $bridge.registerHandler === "function") {
      try {
        return $bridge.registerHandler(name, callback);
      } catch (err) {
        if (isNotInsideMiniAppError(err)) {
          bridgeStub.registerHandler(name, callback);
          return;
        }
        throw err;
      }
    }
    bridgeStub.registerHandler(name, callback);
  },
};
app.config.globalProperties.$bridge = bridge;
app.provide("$bridge", bridge);
app.use(VueAxios, axios);
try {
  if (!window.bridge && app.config && app.config.globalProperties) {
    window.bridge = app.config.globalProperties.$bridge;
  }
  if (!window.$bridge) {
    window.$bridge = app.config.globalProperties.$bridge;
  }
} catch (err) {
  console.warn("window.bridge not exposed:", err);
}
app.mixin(helper).use(router).use(store).mount("#app");
